var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentCalculator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M21.003 11.5v8.503a1 1 0 01-1 1H14a1 1 0 01-1-1V11.5a1 1 0 011-1h6.003a1 1 0 011 1z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.003 14H13M6.496 6.998H15M6.496 10.5h2.501M6.496 14h2.501M9.999 18.003H4.997a2 2 0 01-2-2.001V4.997a2 2 0 012-2h12.005a2 2 0 012 2v3.001M15.75 16.202a.05.05 0 100 .1.05.05 0 000-.1M18.252 16.202a.05.05 0 100 .1.05.05 0 000-.1M15.75 18.703a.05.05 0 100 .1.05.05 0 000-.1M18.252 18.703a.05.05 0 100 .1.05.05 0 000-.1",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgDocumentCalculator;